import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { ITransferStatsParams } from '../../../types';

/**
 * This key is used to track useTransferStatsQuery
 */
export const TRANSFER_STATS_QUERY_KEY = 'transfer-stats-query-key';
/**
 * This hook fetches the transfer stats and refetches when component becomes visible.
 * This is to ensure that the data is always up to date.
 */
export const useTransferStatsQuery = (payload?: ITransferStatsParams) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [TRANSFER_STATS_QUERY_KEY, payload],
    networkMode: 'always',
    staleTime: 0, // Always consider data stale
    gcTime: 1000 * 60 * 5, // Keep in cache for 5 minutes
    refetchOnMount: 'always', // Always refetch when component mounts
    refetchOnWindowFocus: true, // Refetch when window/app gains focus
    refetchOnReconnect: true, // Refetch when network reconnects
    queryFn: () => INV_MGMT_SERVICE_API.getTransferStats(payload),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
